enum PresentersEvents {
    LoadAll = "[Presenters] LoadAll",
    LoadAllComplete = "[Presenters] LoadAllComplete",
    Load = "[Presenters] Load",
    LoadComplete = "[Presenters] LoadComplete",
    SetRoles = "[Presenters] SetRoles",
    SetRolesComplete = "[Presenters] SetRolesComplete",
    SetSkills = "[Presenters] SetSkills",
    SetSkillsComplete = "[Presenters] SetSkillsComplete",
    filterUserListStarted = "[Presenters] filterUserListStarted",
    filterUserListComplete = "[Presenters] filterUserListComplete",
}

export default PresentersEvents;
